const { apiUrl, fbClientId, assetsBaseUrl } = window.APP_CONFIG || {}

export default {
  api: {
    url: apiUrl,
  },
  assets: {
    baseUrl: assetsBaseUrl,
  },
  social: {
    fbClientId,
  },
}
